import { Box, Typography } from '@mui/material';
import COLORS from '@/resources/style/Themes';

// Badge is only shown during this promotional window; outside it, nothing renders.
// UTC-based global window (same instant for all users), matching ProductionFeatureNotification's convention.
const NEW_BADGE_VISIBLE_FROM: Date = new Date('2026-08-13T00:00:00Z');
const NEW_BADGE_VISIBLE_UNTIL: Date = new Date('2026-10-02T23:59:59Z');

const isWithinNewBadgeWindow = (): boolean => {
  const now = Date.now();
  return (
    now >= NEW_BADGE_VISIBLE_FROM.getTime() &&
    now <= NEW_BADGE_VISIBLE_UNTIL.getTime()
  );
};

/**
 * A small "New" pill badge used to call out recently added nav items/features.
 * Only renders between NEW_BADGE_VISIBLE_FROM and NEW_BADGE_VISIBLE_UNTIL.
 */
export const NewBadge = () => {
  if (!isWithinNewBadgeWindow()) return null;

  return (
    <Box
      sx={{
        backgroundColor: COLORS.YELLOW,
        color: COLORS.SAFEGUARD_BLUE,
        borderRadius: '10px',
        padding: '1px 6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        lineHeight: 1,
        zIndex: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: '0.6rem',
          fontWeight: 'bold',
          color: COLORS.SAFEGUARD_BLUE,
          lineHeight: 1,
          letterSpacing: '0.5px',
          textTransform: 'capitalize',
        }}
      >
        new
      </Typography>
    </Box>
  );
};

export default NewBadge;
